<xemex-dialog-shell [title]="'partnerships.create.title' | translate">
  <form [formGroup]="form" class="flex flex-col gap-4 p-2">
    @if (requiresPartnerSelection()) {
      <div>
        <xemex-partner-select
          [formControl]="ownerControl"
          [label]="'partnerships.create.ownerLabel' | translate"
          [placeholder]="'partnerships.create.partnerPlaceholder' | translate"
        />
        @if (partnerError()) {
          <span class="block mt-1 text-xs text-red-500">
            {{ 'partnerships.create.noOwner' | translate }}
          </span>
        }
      </div>
    }

    <!-- Guest selection -->
    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium">{{ 'partnerships.create.guestLabel' | translate }}</span>
      <xemex-button-toggle formControlName="guestMode" [options]="guestModeOptions" />

      @if (form.controls.guestMode.value === 'existing') {
        <xemex-partner-select
          [formControl]="form.controls.guestPartnerOid"
          [placeholder]="'partnerships.create.partnerPlaceholder' | translate"
        />
      } @else {
        <xemex-text-field
          formControlName="guestEmail"
          type="email"
          [label]="'partnerships.create.guestEmail' | translate"
          [placeholder]="'login.form.placeholderEmail' | translate"
        />
        <xemex-text-field
          formControlName="guestName"
          [label]="'partnerships.create.guestName' | translate"
        />
      }

      @if (guestError()) {
        <span class="block text-xs text-red-500">
          {{ 'partnerships.create.guestRequired' | translate }}
        </span>
      }
    </div>

    <!-- Partnership type -->
    <xemex-select-field
      [label]="'partnerships.table.type' | translate"
      [required]="true"
      [invalid]="form.controls.partnershipType.invalid && form.controls.partnershipType.touched"
      [errorText]="'error.required' | translate: { field: ('partnerships.table.type' | translate) }"
    >
      <mat-select
        formControlName="partnershipType"
        [placeholder]="'partnerships.create.typePlaceholder' | translate"
      >
        @for (type of partnershipTypes(); track type.typeCode) {
          <mat-option [value]="type.typeCode">
            <span class="font-medium">{{ type.typeCode }}</span>
            @if (type.description) {
              <span class="text-xs text-gray-500"> · {{ type.description }}</span>
            }
          </mat-option>
        }
      </mat-select>
    </xemex-select-field>

    <!-- End date (defaults to one year from today); maps to the API's reviewDueDate field. -->
    <div>
      <xemex-text-field
        formControlName="reviewDueDate"
        type="date"
        [label]="'partnerships.table.endDate' | translate"
      />
      <span class="block mt-1 text-xs text-gray-500">
        {{ 'partnerships.create.endDateHint' | translate }}
      </span>
    </div>

    <!-- Initial installation groups (optional) -->
    <xemex-select-field [label]="'partnerships.create.installationGroups' | translate">
      <mat-select
        formControlName="installationGroupOids"
        multiple
        [placeholder]="'partnerships.create.installationGroupsPlaceholder' | translate"
      >
        @if (isLoadingGroups()) {
          <mat-option disabled>{{ 'general.loading' | translate }}</mat-option>
        } @else if (!installationGroups().length) {
          <mat-option disabled>
            {{ 'partnerships.create.noInstallationGroups' | translate }}
          </mat-option>
        } @else {
          @for (group of installationGroups(); track group.installationGroupOid) {
            <mat-option [value]="group.installationGroupOid">{{ group.name }}</mat-option>
          }
        }
      </mat-select>
    </xemex-select-field>
  </form>

  <mat-dialog-actions actions>
    <xemex-filled-button type="button" (click)="onCreate()">
      {{ 'general.btnCreate' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
